/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerModelConfigurationDto } from '../models/EntityModelResponseContainerModelConfigurationDto';
import type { ModelConfigurationDto } from '../models/ModelConfigurationDto';
import type { PagedModelEntityModelModelConfigurationDto } from '../models/PagedModelEntityModelModelConfigurationDto';
import type { PagedResourcesAssemblerModelConfigurationDto } from '../models/PagedResourcesAssemblerModelConfigurationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ModelConfigurationControllerService {
    /**
     * @returns PagedModelEntityModelModelConfigurationDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerModelConfigurationDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelModelConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/model_configuration',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerModelConfigurationDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ModelConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerModelConfigurationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/model_configuration',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerModelConfigurationDto OK
     * @throws ApiError
     */
    public static update({
        requestBody,
    }: {
        requestBody: ModelConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerModelConfigurationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/model_configuration',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        modelConfigurationId,
    }: {
        modelConfigurationId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/model_configuration/{modelConfigurationId}',
            path: {
                'modelConfigurationId': modelConfigurationId,
            },
        });
    }
}
